import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Input() isCollapsed = true;
  @Input() currentUser;

  constructor(
      private router: Router,
  ) {
  }

  ngOnInit(): void {
    // document.getElementsByClassName('submenu_container')
  }

  openExternalRedirectApp(app) {
    switch (app.label) {
        // case 'MailAgile':
        //   this.iframeService.getMailAgileUrl().subscribe((res: any) => {
        //     this.openExternalApp(res.url);
        //   });
        //   break;

    }
  }

  openExternalApp(url) {
    let tab = window.open("", "_blank");
    tab.location.href = url;
  }

  navigate(app) {
    switch (app.type) {
      case 'iframes':
      case 'applications':
        this.router.navigate([app.url]);
        break;
      case 'external':
        this.openExternalApp(app.url);
        break;
      case 'external-redirect':
        this.openExternalRedirectApp(app);
        break;
    }
  }

  clickMenu(){
    if (!this.isCollapsed) {
      document.getElementById("header-trigger").click();
    }
  }

}
